/* jshint esversion: 6, -W097 */
/* globals require */
'use strict';

/**
 * Lists orders placed
 */
function orderTransactionsDirective() {
    return {
        restrict: 'E',
        scope: {
            orderList: '<',
        },
        controllerAs: 'vm',
        bindToController: true,
        controller: OrderTransactionsController,
        template: require('./orderTransactionsView.html')
    };
}

OrderTransactionsController.$inject = ['$filter', '$scope'];
function OrderTransactionsController($filter, $scope) {
    this.$onInit = function() {
        $scope.$watch('vm.orderList', formatOrders, true);

        /**
         * Formats the orders for the view.
         *
         * @param {Array} orderList - Orders to be formatted.
         */
        function formatOrders(orders) {
            orders.forEach((order) => {
                let {created_at, order_number, shipping_status, tracking_number, lines} = order;
                created_at = $filter('date')(new Date(created_at), 'longDate');
                // Create a context object for the CMS. This is necessary because orders have a property
                // that is an array (lines), and the CMS service handles arrays in a special way.
                order.cms_context = {
                    created_at,
                    order_number,
                    shipping_status,
                    tracking_number,
                    partner_name: lines[0].partner_name
                };
            });
        }
    }
}

module.exports = orderTransactionsDirective;
